<template>
    <div class="project-template">
      <div class="project-template-left">
        <div class="temp-footer">
          <a-button @click="lastClick">上一步</a-button>
          <a-button @click="nextClick" style="margin-left: 10px" type="primary">成本核算</a-button>
        </div>
      </div>
      <div class="project-template-right">
        xxxx
      </div>
    </div>
</template>

<script>
  import PeriodItemCard from './projectTemplate2/comp/PeriodItemCard'
  import Module from './projectTemplate2/Module'
  import Disease from '@views/apppad/projectTemplate/projectTemplate2/Disease.vue'
  import Dept from '@views/apppad/projectTemplate/projectTemplate2/Dept.vue'
  import { getAction } from '@api/manage'
  export default {
    name: 'ProjectTemplate_bak',
    components: { Dept, Disease, Module, PeriodItemCard  },
    data(){
      return {
        data:[],
        projectId:'',
      }
    },
    watch:{
      data(){
      },
    },
    mounted(){
      this.projectId = this.$route.query.id
      this.loadProjectData()
    },
    methods:{
      loadProjectData(){
        const id = this.$route.query.id
        getAction('/projectconfigview/configProject/queryById', { id:id }).then(res=>{
          if(res.success){
            this.model = res.result
            this.handleDept()
            this.handleDisease()
          }
        })
      },
      nextClick(){
        this.$emit('next')
      },
      lastClick(){
        this.$emit('last')
      },
    }
  }
</script>

<style scoped lang="less">
  .parent {
    width: 100%;
    height: 400px;
    padding-left: 10px;
    display: flex;
    overflow-x: auto;
  }
  .children {
    height: 300px;
    margin: 20px 20px 0 0;
    position: relative;
    .btn{
      position: absolute;
      right: -10px;
      top: -10px;
    }
  }
  .arrow-right{
    line-height: 300px;
  }
</style>